const footerEn = {
  company: 'Grameen Bazar',
  description: 'Bangladesh’s largest online marketplace. Find everything you need every day.',
  links: {
    company: 'Company',
    business: 'Business',
    support: 'Support',
    about: 'About Us',
    career: 'Career',
    contact: 'Contact',
    help: 'Help',
    becomeSeller: 'Become a Seller',
    businessAccount: 'Business Account',
    marketplacePolicy: 'Marketplace Policy',
    deliveryPolicy: 'Delivery Policy',
    returnPolicy: 'Return Policy',
    privacyPolicy: 'Privacy Policy',
  },
  contact: {
    heading: 'Contact',
    address: 'House #123, Road #45, Banani, Dhaka-1213',
  },
  copyright: (year) => `© ${year} Grameen Bazar. All rights reserved.`,
};

export default footerEn;


